import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import {
  getReturnsPurchaseById,
  cleanUpReturnsPurchaseById,
} from '@store/purchases/ReturnsPurchase/returnsPurchaseSlice';


interface Props {
  id: string | undefined;
}

const useGetReturnsPurchaseById = ({ id }: Props) => {

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (id) {
      dispatch(getReturnsPurchaseById(id));
    }

    return () => {
      dispatch(cleanUpReturnsPurchaseById());
    };
  }, [dispatch, id]);
  const { ReturnsPurchaseById, loading, error } = useAppSelector((state) => state.ReturnsPurchase);

  return { ReturnsPurchaseById, loading, error };
};

export default useGetReturnsPurchaseById;
